function Loading() {
  return (
    <div className={`w-full h-full flex justify-center items-center`}>
      <div className={`lds-ripple`}><div></div><div></div></div>
 

    </div>
  )
}

export default Loading